import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AiModelDto } from './models/ai-model.model';

export const AiModelsActions = createActionGroup({
  source: 'AI Models',
  events: {
    Init: emptyProps(),
    'Get AI Models': props<{ tenantUuid: string; aiProviderUuidList?: string[] }>(),
    'Load Success': props<{ aiModels: readonly AiModelDto[] }>(),
    'Load Failure': props<{ error: unknown }>(),
    Clear: emptyProps(),
  },
});
